import { PhoneVO } from '@zazume/zzm-utils';

/**
 * Returns the user's phone number in international format to prefill the "Call us" form,
 * or an empty string when there is no valid phone number.
 *
 * `PhoneVO.from` throws on null/invalid input (FRONT-4J3), so the value must be guarded
 * with `PhoneVO.isValid` before building the value object.
 */
export const getInitialContactPhone = (phoneNumber: unknown): string =>
  PhoneVO.isValid(phoneNumber) ? PhoneVO.from(phoneNumber).international : '';
